import { similarOffersReceived } from './similarOffersReceived';
import { getUserBasedSimilarOffers } from '../../../api/similar';
import { IThunkActionCreator } from '../../index';

export function requestUserBasedSimilarOffers(
  offerId: number,
  publishedUserId: number | null,
): IThunkActionCreator<Promise<void>> {
  return (dispatch, getState, context) => {
    // обработки ошибок нет, и это нормально — деградируем без показа блока
    return getUserBasedSimilarOffers(context, { cianOfferId: offerId, publishedUserId }).then(res => {
      if (res.statusCode === 200) {
        dispatch(similarOffersReceived(res.response, 'userBased'));
      }
    });
  };
}
